import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import plCommon from './locales/pl/common.json';
import enCommon from './locales/en/common.json';
import plAuth from './locales/pl/auth.json';
import enAuth from './locales/en/auth.json';
import plDashboard from './locales/pl/dashboard.json';
import enDashboard from './locales/en/dashboard.json';
import plDogs from './locales/pl/dogs.json';
import enDogs from './locales/en/dogs.json';
import plTrainings from './locales/pl/trainings.json';
import enTrainings from './locales/en/trainings.json';
import plCalendar from './locales/pl/calendar.json';
import enCalendar from './locales/en/calendar.json';
import plExercises from './locales/pl/exercises.json';
import enExercises from './locales/en/exercises.json';
import plGroups from './locales/pl/groups.json';
import enGroups from './locales/en/groups.json';
import plReports from './locales/pl/reports.json';
import enReports from './locales/en/reports.json';
import plSurveys from './locales/pl/surveys.json';
import enSurveys from './locales/en/surveys.json';
import plSchool from './locales/pl/school.json';
import enSchool from './locales/en/school.json';
import plAccount from './locales/pl/account.json';
import enAccount from './locales/en/account.json';
import plSubscription from './locales/pl/subscription.json';
import enSubscription from './locales/en/subscription.json';
import plChat from './locales/pl/chat.json';
import enChat from './locales/en/chat.json';
import plOnboarding from './locales/pl/onboarding.json';
import enOnboarding from './locales/en/onboarding.json';
import plHelp from './locales/pl/help.json';
import enHelp from './locales/en/help.json';

const NAMESPACES = [
  'common', 'auth', 'dashboard', 'dogs', 'trainings', 'calendar',
  'exercises', 'groups', 'reports', 'surveys', 'school', 'account',
  'subscription', 'chat', 'onboarding', 'help',
];

const resources = {
  pl: {
    common: plCommon,
    auth: plAuth,
    dashboard: plDashboard,
    dogs: plDogs,
    trainings: plTrainings,
    calendar: plCalendar,
    exercises: plExercises,
    groups: plGroups,
    reports: plReports,
    surveys: plSurveys,
    school: plSchool,
    account: plAccount,
    subscription: plSubscription,
    chat: plChat,
    onboarding: plOnboarding,
    help: plHelp,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    dogs: enDogs,
    trainings: enTrainings,
    calendar: enCalendar,
    exercises: enExercises,
    groups: enGroups,
    reports: enReports,
    surveys: enSurveys,
    school: enSchool,
    account: enAccount,
    subscription: enSubscription,
    chat: enChat,
    onboarding: enOnboarding,
    help: enHelp,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    defaultNS: 'common',
    ns: NAMESPACES,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;
